'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';

export default function HomePage() {
  const { session, loading, userRole } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading) {
      if (session) {
        const destination = userRole === 'admin' ? '/admin-dashboard' : '/partner-dashboard';
        router?.replace(destination);
      } else {
        router?.replace('/sign-up-login-screen');
      }
    }
  }, [session, loading, userRole, router]);

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}